function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M52.6409 11H26.8601C16.7797 11 10 17.9327 10 28.2442V52.0425C10 62.3249 16.7797 69.2576 26.8601 69.2576H52.6409C62.7213 69.2576 69.4713 62.3249 69.4713 52.0425V28.2442C69.4713 17.9327 62.7213 11 52.6409 11Z",
  fill: "url(#clock_paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M49.2189 50.9343C49.5787 51.1411 49.9712 51.2401 50.3608 51.2401C51.119 51.2401 51.8595 50.8585 52.2787 50.174C52.5565 49.7171 52.6443 49.2015 52.5654 48.7145C52.4654 48.0957 52.0963 47.523 51.5055 47.1758L40.9197 40.9918V27.5322C40.9197 26.3263 39.9206 25.3475 38.6895 25.3475C37.4585 25.3475 36.4594 26.3263 36.4594 27.5322V42.2326L36.4592 42.2326C36.4592 42.3477 36.4685 42.4616 36.4865 42.5734C36.5886 43.2085 36.973 43.7753 37.5447 44.1123L49.2189 50.9343Z",
  fill: "url(#clock_paint3_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "clock_paint0_linear",
  x1: 65.2175,
  y1: 11,
  x2: 3.68541,
  y2: 54.3649,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#39AFFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4E77FB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "clock_paint3_linear",
  x1: 51.4493,
  y1: 30.0232,
  x2: 33.4659,
  y2: 30.3886,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8D3FF"
})));

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "assets/media/Clock.1324c4bc.svg";
export { ForwardRef as ReactComponent };